import { marked } from 'marked';
import scrollToBottom from "../scrollBottom";

marked.setOptions({
  breaks: true,
  gfm: true,
  headerIds: false,
  sanitize: true
});

function formatMessageDateTime() {
  const now = new Date();
  const time = now.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
  });

  return time;
}

let renderBublesChat = async (containner, converstaions, preloader) => {  
  containner.innerHTML = ''; 
  converstaions.map((bubles) => {
      const timeString = formatMessageDateTime();
      const renderedContent = marked.parse(bubles.data.content.replace(/(?:\-)/g, ' '));
      containner.innerHTML += `<div class=${
          bubles.type != "human" ? "bublesAi" : "bublesYou"
      }><div class="any_subjectBoxWrapper"><div class="any_subjectBox">
          ${
              bubles.type != "human"
              ? `<div class="icon-wrapper" style="width: 25px; height: 25px; border-radius: 50%; background-color:#${anyBacken.primaryColor}; display: flex; justify-content: center; align-items: center;"><img src="${anyBacken.botIcon}" style="width: 15px; height: 15px;" alt="botIcon"></div>`
              : ""
          }
          <span class="any_botName">${bubles.type == 'human' ? "Tú" : anyBacken.sparkName.replace(/(?:\-)/g, ' ')}</span> 
          </div> <span style="background-color:#${bubles.type != "human" ? 'fffff' : anyBacken.secondaryColor};">${renderedContent}</span>
          <small class="message-time">${timeString}</small>
          </div></div>`;
  });
  scrollToBottom(containner);
}
  export default renderBublesChat;